import { User } from 'actions/userActions';

export const isExploSuperuser = (user: User) => {
  return user.is_superuser && user.email.endsWith('@explo.co');
};
